import { Flex, Text, useMediaQuery } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { HelperText } from './HelperText';
import InfoPopover from 'components/forms/InfoPopover';
import { useWizardState } from 'components/wizard/hooks/useWizardState';

export function StepDetails() {
    const [isDesktop] = useMediaQuery('(min-width: 769px)');
    const { currentStep } = useWizardState();

    const title = currentStep?.title;
    const info = currentStep?.info;
    const description = currentStep?.description;
    const helperText = currentStep?.helperText;

    if (!currentStep) {
        throw new Error('Invalid wizard state: currentStep is not defined');
    }

    return (
        <Flex flexDir="column" flexShrink={0} mb={5}>
            <Flex gap={2} mb={4} alignItems={'center'}>
                {title && (
                    <Text fontSize="lg" fontWeight="semibold" color="black">
                        {typeof title === 'string' ? title : <FormattedMessage {...title} />}
                    </Text>
                )}
                {info && (
                    <InfoPopover
                        width={isDesktop ? '2xl' : 'sm'}
                        info={typeof info === 'string' ? info : <FormattedMessage {...info} />}
                    />
                )}
            </Flex>
            {description && (
                <Text fontSize="larger" mb={4} color="black">
                    {typeof description === 'string' ? description : <FormattedMessage {...description} />}
                </Text>
            )}
            {helperText && (
                <HelperText>
                    {typeof helperText === 'string' ? helperText : <FormattedMessage {...helperText} />}
                </HelperText>
            )}
        </Flex>
    );
}
